import { createFileRoute } from "@tanstack/react-router";
import OwnerEvalPage from "@/pages/OwnerEvalPage";

export const Route = createFileRoute("/_owner/owner/eval")({
  component: OwnerEvalPage,
});
